import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';

import { EuiMessageBoxComponent, EuiMessageBoxFooterDirective } from './eui-message-box.component';
import { EuiButtonModule } from '../eui-button';
import { EuiIconModule } from '../atoms';
import { EuiMessageBoxService } from './services/eui-message-box.service';
import { EuiMessageBoxContainerComponent } from './container/eui-message-box-container.component';

@NgModule({
    imports: [
        CommonModule,
        EuiButtonModule,
        EuiIconModule,
        TranslateModule,
        PortalModule,
        OverlayModule,
        A11yModule,
    ],
    exports: [
        EuiMessageBoxComponent,
        EuiMessageBoxFooterDirective,
    ],
    declarations: [
        EuiMessageBoxComponent,
        EuiMessageBoxFooterDirective,
        EuiMessageBoxContainerComponent,
    ],
    providers: [
        EuiMessageBoxService,
    ],
})

export class EuiMessageBoxModule {
}
